<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    :class="className"
  >
    <circle cx="10.9999" cy="5.50065" r="3.66667" fill="#AAB6CD" />
    <path
      d="M18.3334 16.041C18.3334 18.3192 18.3334 20.166 11.0001 20.166C3.66675 20.166 3.66675 18.3192 3.66675 16.041C3.66675 13.7628 6.94999 11.916 11.0001 11.916C15.0502 11.916 18.3334 13.7628 18.3334 16.041Z"
      fill="#AAB6CD"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UserIcon',
  props: {
    fillColor: {
      type: String,
      default: '#84838C'
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = props.class
    return {
      className
    }
  }
})
</script>
